export default __webpack_public_path__ + "static/media/曹昱.8de4dc28.jpg";